// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__9QVyN","firstName":"Profile_firstName__gjnho","lastName":"Profile_lastName__kulu3"};